import React from "react";
import visavoyage from "../assets/images/visavoyage.webp";

const benefits = [
  {
    icon: "las la-globe",
    title: "Worldwide Coverage",
    text: "Visas for over 100+ destinations. End-to-End Support - From documentation to submission.",
  },
  {
    icon: "las la-bolt",
    title: "Faster Approvals",
    text: "Smart checks to avoid delays and ensure a smoother visa application process.",
  },
  {
    icon: "las la-user-tie",
    title: "Trusted Expertise",
    text: "Experienced consultants with updated processes to guide your application.",
  },
  {
    icon: "las la-tags",
    title: "Transparent Pricing",
    text: "Clear and upfront pricing with no hidden fees throughout the process.",
  },
];

export default function VisaSection() {
  return (
    <section
      className="max-w-7xl mx-auto overflow-hidden md:py-16 md:scroll-mt-12 py-6"
      id="visa"
    >
      <div
        className="
          relative
          px-5 sm:px-8 md:px-[2.75%]
          bg-[#f6fbfe]
          py-10 sm:py-12 md:py-16
          rounded-lg
        "
      >
        {/* ================= TOP LABEL ================= */}
        <div className="mx-auto mb-3 flex items-center justify-start md:justify-center gap-4">
          <span
            className="
              inline-block
              text-[12px] sm:text-sm md:text-base
              font-bold
              tracking-[0.15em] md:tracking-[0.2em]
              text-[#007FC0]
            "
          >
            Global Visa Service
          </span>
        </div>

        {/* ================= HEADING ================= */}
        <h2
          className="
            text-left md:text-center
            m-0
            text-[30px] sm:text-[38px] md:text-[58px] lg:text-[50px]
            font-semibold
            leading-[1.15]
            tracking-[-0.5px] md:tracking-[0.2px]
            text-[#12344A]
          "
        >
          Travel the World, we'll
          <br className="hidden sm:block" />
          <span className="text-[#12344A]"> Handle the Paperwork</span>
        </h2>

        {/* ================= CONTENT ================= */}
        <div className="flex flex-col md:flex-row md:pt-20 pt-10">
          {/* ================= LEFT ================= */}
          <div className="relative w-full md:w-6/12 md:pr-24">
            <h2
              className="
                text-left
                text-[#12344A]
                text-[17px] sm:text-[19px] md:text-[22px]
                leading-[1.6]
                tracking-[-0.1px]
                font-medium
                m-0
              "
            >
              Expert visa support from start to finish. Travel confidently—we
              handle the details.
            </h2>

            <img
              src={visavoyage}
              alt="Visa services"
              className="
                md:w-11/12 w-full
                h-auto
                sm:h-[320px]
                md:h-[390px]
                object-cover
                rounded-lg
                mt-2 sm:mt-10 md:mt-2
              "
            />
          </div>

          {/* ================= RIGHT ================= */}
          <div className="w-full md:w-6/12 pt-10 md:pt-[2px] md:pr-[20px]">
            <div className="flex flex-col gap-7 sm:gap-8 md:gap-[33px]">
              {benefits.map((benefit, index) => {
                return (
                  <div
                    key={index}
                    className="
                      flex
                      items-start
                      gap-4 sm:gap-5 md:gap-[25px]
                    "
                  >
                    {/* ICON */}
                    <div
                      className="
                        shrink-0
                        w-[46px] h-[46px]
                        sm:w-[50px] sm:h-[50px]
                        md:w-[56px] md:h-[56px]
                        rounded-full
                        bg-[#ecf7fe]
                        flex
                        items-center
                        justify-center
                      "
                    >
                      <i
                        className={`
                          ${benefit.icon}
                          text-sky-800
                          text-[21px]
                          sm:text-[24px]
                          md:text-[28px]
                        `}
                      />
                    </div>

                    {/* CONTENT */}
                    <div className="flex-1 min-w-0">
                      <h2
                        className="
                          m-0
                          pt-0.5
                          text-left
                          text-[#12344A]
                          text-[17px]
                          sm:text-[18px]
                          md:text-[19px]
                          leading-[1.4]
                          tracking-[-0.2px]
                          font-bold
                        "
                      >
                        {benefit.title}
                      </h2>

                      <p
                        className="
                          m-0
                          pt-1
                          text-left
                          text-[#536B7A]
                          text-[14px]
                          sm:text-[15px]
                          md:text-[17px]
                          leading-[1.55]
                          tracking-[-0.1px]
                          font-normal
                        "
                      >
                        {benefit.text}
                      </p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
